import { Star } from "lucide-react";

export const StarRating = ({ value = 0, onChange, starClass = "w-6 h-6", readOnly = false }) => (
  <div className="flex gap-1">
    {[1, 2, 3, 4, 5].map((i) => (
      <button
        key={i}
        type="button"
        disabled={readOnly}
        onClick={() => onChange && onChange(i)}
        data-testid={readOnly ? undefined : `star-${i}`}
        className={readOnly ? "cursor-default" : "cursor-pointer transition-transform hover:scale-110"}
      >
        <Star className={`${starClass} ${i <= value ? "fill-amber-400 text-amber-400" : "text-slate-300"}`} />
      </button>
    ))}
  </div>
);
